"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Currency = void 0;
let Currency = exports.Currency = /*#__PURE__*/function (Currency) {
  Currency["EUR"] = "eur";
  Currency["USD"] = "usd";
  Currency["GBP"] = "gbp";
  Currency["AUD"] = "aud";
  return Currency;
}({});